import { useEffect, useState } from "react";
import { reminderAPI } from "services";
import useUniversalStore from "store/universalStore";
import { offsetDateByMinutes } from "utils";
import dayjs from "dayjs";
import AddReminder from "./AddReminder";
import { toast } from "sonner";

const Reminder = () => {
  const { accountId, write, isReminderChanged } = useUniversalStore((state) => state);
  
  const [reminder, setReminder] = useState(null);
  const [scheduleReminder, setScheduleReminder] = useState(offsetDateByMinutes(5));
  const enabled = reminder?.get("enabled");
  const reminderDateTime = reminder?.get("date");

  // overdue is true if reminder date and time less then current date and time
  const overDue = new Date().getTime() > reminderDateTime?.getTime();

  //intially fetch the reminder details
  useEffect(() => {
    fetchReminder();
  }, [accountId]);

  //method to fetch reminder and add results in global store
  const fetchReminder = async () => {
    try {
      //handleLoading(true)
      const response = await reminderAPI.fetchReminder(accountId);
      setReminder(response[0]);
      setScheduleReminder(response[0]?.get("date") || offsetDateByMinutes(5));
    } catch (error) {
      toast.error("Failed to fetch the reminder!")
    }finally{
      //handleLoading(false)
    }
  };

  //method to toggle Reminder
  const handleReminderToggle = async () => {
    try {
      //handleLoading(true)
      const res = await reminderAPI.toggleReminder(reminder?.id);
      if(res){
        write({isReminderChanged:false})
        setReminder(res);
      }
    } catch (error) {
      toast.error("Failed to toggle the reminder!")
    }finally{
      //handleLoading(false)
    }
  };

  //method to delete the reminder
  const handleDeleteReminder = async () => {
    try {
      const response = await reminderAPI.deleteReminder(reminder?.id);
      if (response) {
        
        toast.success("Reminder has been removed successfully!");
        setReminder(null);
        setScheduleReminder(offsetDateByMinutes(5));

        //TODO: Update global store.
        write({isReminderChanged:!isReminderChanged})
      }
    } catch (error) {
      toast.error("Failed to delete the reminder!")
    }finally{
      //handleLoading(false)
    }
  };

  if(!reminderDateTime) return <AddReminder />;
  return (
    <small className="text-muted mb-2">
      <div className="alert">
        <h4 className="display-6 text-center text-dark">Current Reminder</h4>
        {overDue ? (
          <div className="text-danger text-center h6 my-2">
            <i className="bi bi-patch-exclamation"></i> Payment Overdue
          </div>
        ) : null}
      </div>
      <div className="row">
        <ul className="list-group list-group-horizontal col-12 my-2 p-0">
          <li className="list-group-item col-8">
            <h3 className={`text-left ${enabled ? "text-danger" : ""}`}>
              {scheduleReminder ? (
                <>
                  <i className="bi bi-calendar-fill" />
                  <i className="px-2 fs-5">{dayjs(scheduleReminder).format("DD-MM-YYYY hh:mm A")}</i>
                </>
              ) : ("N/A")}
            </h3>
          </li>
          <li className="list-group-item col-2">
            <i className={`my-auto fs-3 bi bi-toggle2-${enabled ? "on" : "off"}`}
              data-bs-dismiss={overDue ? "offcanvas" : ""}
              onClick={handleReminderToggle}
              type="button"
              title="Disable Reminder"
            ></i>
          </li>
          <li className="list-group-item col-2">
            <i
              className="bi bi-trash my-auto fs-3"
              data-bs-dismiss="offcanvas"
              onClick={handleDeleteReminder}
              type="button"
              title="Delete Reminder"
            ></i>
          </li>
        </ul>
      </div>
    </small>
  )
}

export default Reminder;